export function determineFirstDayOfMonthContainngTimeVal(dateInMillis){
	var firstDayOfMonth = '';
	
	if(dateInMillis == null){
		return firstDayOfMonth;
	}

	var dateWithinMonth = new Date(dateInMillis);
	var dateMonth = dateWithinMonth.getMonth() + 1;
	
	var dateMonthString = dateMonth.toString();
	if(dateMonth < 10){
		dateMonthString = "0" + dateMonthString;
	}

	var dateYear = dateWithinMonth.getFullYear();
	var newDateString = dateYear + "-" + dateMonthString + "-01T00:00:00";
	firstDayOfMonth = new Date(newDateString);
	
	return firstDayOfMonth;	
}

export function getCurrencySymbol(currencyCode){
	var currSymbol =""; 
	 if("GBP" == currencyCode) {
		 currSymbol = "\u00A3 " ;
     } else if("EUR" == currencyCode) {
    	 currSymbol = "\u20AC ";
     } else if("USD" == currencyCode) {
    	 currSymbol = "\u0024" ;
     }
	 return currSymbol;
}
export function getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage){
	var scrollBarCssStyle = "width:" + 865/dataDisplayPercentage + "px;height:100px";
	return scrollBarCssStyle;
}
export function mergeAllBorrowerViewData(vm, tableIdParam){
	var allData = [];
	
	try{
		Array.prototype.push.apply(allData, vm[tableIdParam]);	
	}catch(exception){
        console.log(exception)
	}		

	return allData;
}
export function mergeAllHomeViewData(vm, tableIdParam){
	var allData = [];

	var onLoanDataMode = false;
	var elementCount = 4;
	
	if(tableIdParam.toLowerCase().includes("onloan")){
		onLoanDataMode = true;
		elementCount = 3;
	}
		
	for(let i=0; i<elementCount; i++){
		const elementName = tableIdParam + i.toString();
		var dataArray = vm[elementName];		
		Array.prototype.push.apply(allData, dataArray);		
	}
	
	return allData;
}
export function getLastRecordForBorrowerView(dataset){
	
	var lastRecord = null;
	
	var allRecords = [];
	
	Array.prototype.push.apply(allRecords, dataset);	

	if(allRecords.length > 0){
		lastRecord = selectRecordWithMaxValuePerFieldName(allRecords, 'effectiveDate');
	}
	
	return lastRecord;	
}
export function getLastRecordForHomeView(vm, datasetId){
	
	var lastRecord = null;

	var allRecords = mergeAllHomeViewData(vm, datasetId);

	if(allRecords.length > 0){
		lastRecord = selectRecordWithMaxValuePerFieldIndex(allRecords, 0);
	}
	
	return lastRecord;	
}
export function getScrollBarCssPerDisplayPercentage(dataDisplayPercentage){
	var scrollBarCssStyle = "width:" + 714/dataDisplayPercentage + "px;height:100px";
	return scrollBarCssStyle;
}
export function show(name, obj){
    alert(name + ": |" + JSON.stringify(obj) + "|")
}
export function formatCurrency(rawCurrency, optionalDecimalPointCount){

    var decimalPointCount = 0;

    if(optionalDecimalPointCount == undefined){
        decimalPointCount = 2;
    }



    var simpleValue = rawCurrency;
    var multiplier = '';

    //Figure in the Thousands?
    var denominator = 1000
    var divisor = rawCurrency/denominator;
    if(divisor >= 1){
        multiplier = 'K';
        simpleValue = rawCurrency/denominator;
    } 

    //Figure in the Millions?
    denominator = 1000000
    divisor = rawCurrency/denominator;
    if(divisor >= 1){
        multiplier = 'M';
        simpleValue = rawCurrency/denominator;
    } 

    //Figure in the Billions?
    denominator = 1000000000
    divisor = rawCurrency/denominator;
    if(divisor >= 1){
        multiplier = 'B';
        simpleValue = rawCurrency/denominator;
    } 

    return simpleValue.toFixed(decimalPointCount).toString() + ' ' + multiplier;
}    
export function getRecordsWithinRange(dataset, startDate, endDate){
    var recordsInRange = []
     
    var datum = ''

    var index = 0;

    var count = 0

    for(datum of dataset){
        var currentDate = new Date(datum.effectiveDate)
        if((currentDate > startDate) && (currentDate < endDate)){
            recordsInRange.push(datum)
        }
    }
    
    return recordsInRange
}
export function selectRecordWithMaxValuePerFieldIndex(arrayList, fieldIndex){
	var targetedRecord = '';
		
	var maxValue = null;
		
	for(let currentArray of arrayList){
		var currentValue = currentArray[fieldIndex];

		if(currentValue == null){
				continue;
		}

		if(maxValue == null){
			maxValue = currentValue;
			targetedRecord = currentArray;
		} else{
			if(currentValue > maxValue){
			maxValue = currentValue;
			targetedRecord = currentArray;
			}
		}
	}
	return targetedRecord;
}
export function selectRecordWithMaxValuePerFieldName(arrayList, fieldName){
	var targetedRecord = '';
		
	var maxValue = null;
		
	for(let currentArray of arrayList){
		var currentValue = currentArray[fieldName];

		if(currentValue == null){
				continue;
		}

		if(maxValue == null){
			maxValue = currentValue;
			targetedRecord = currentArray;
		} else{
			if(currentValue > maxValue){
			maxValue = currentValue;
			targetedRecord = currentArray;
			}
		}
	}
	return targetedRecord;
}
export function selectRecordsWithinRangePerDateIndex(dataset, dateIndex, startDate, endDate){
    var recordsInRange = []
     
    var datum = ''

    var index = 0;

    var count = 0

    for(datum of dataset){
        var  millidate = datum[dateIndex]

        if(millidate == null || millidate < 1){
            break;    
        }

        count = count + 1

        if((millidate > startDate) && (millidate < endDate)){
            recordsInRange.push(datum)
        }
    }
    
    return recordsInRange
}

export function selectSpecifiedElements(items, beginningPercent, endingPercent){
	var selections = [];
    var itemCount = items.length;
	
	var firstItem = (beginningPercent * itemCount);
	
	var lastItem = (endingPercent * itemCount);
	
	var count = 0;
	
	for(var item of items){
		count++;
		
		if((count >= firstItem) && (count <= lastItem)){
			selections.push(item);
		}		
	}
	
    return selections;
}
